import { useEffect, useState } from "react";
import { api } from "@/lib/api";

export default function Announcements({ limit = 4 }) {
    const [items, setItems] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        api.get("/announcements", { params: { limit } })
            .then((r) => setItems(r.data || []))
            .catch(() => setItems([]))
            .finally(() => setLoading(false));
    }, [limit]);

    if (loading || items.length === 0) return null;

    return (
        <div className="space-y-3" data-testid="announcements-list">
            {items.map((a) => (
                <div key={a.id} className="op-card p-5 border-l-2 border-tff7a1a" data-testid={`announcement-${a.id}`}>
                    <div className="flex items-center gap-2">
                        {a.pinned && <span className="text-tff7a1a">📌</span>}
                        <h3 className="text-tffffff font-bold text-lg">{a.title}</h3>
                    </div>
                    <p className="text-tc9ccd3 text-sm mt-2 whitespace-pre-wrap leading-relaxed">{a.body}</p>
                    <div className="op-mono text-[10px] text-t5c6370 mt-3">
                        {a.author_name} · {(a.created_at || "").slice(0, 16).replace("T", " ")}
                    </div>
                </div>
            ))}
        </div>
    );
}
